import { cn } from "@/lib/utils";

export type ActionBadgeType =
  | "neutral"
  | "nutrition"
  | "exercise"
  | "screening"
  | "lifestyle"
  | "medication";

export interface ActionBadgeProps {
  label?: string;
  type?: ActionBadgeType;
  icon?: React.ReactNode;
  className?: string;
}

const TYPE_STYLES: Record<ActionBadgeType, { bg: string; text: string }> = {
  neutral: { bg: "bg-neutral-100", text: "text-neutral-700" },
  nutrition: { bg: "bg-green-50", text: "text-green-700" },
  exercise: { bg: "bg-blue-50", text: "text-blue-700" },
  screening: { bg: "bg-aubergine-50", text: "text-aubergine-700" },
  lifestyle: { bg: "bg-amber-50", text: "text-amber-700" },
  medication: { bg: "bg-error-100", text: "text-error-700" },
};

export function ActionBadge({
  label,
  type,
  icon,
  className,
}: ActionBadgeProps) {
  const isOutlined = !type;
  const styles = type ? TYPE_STYLES[type] : null;
  const isIconOnly = !!icon && !label;

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full py-1",
        isIconOnly ? "px-1.5" : "pl-1.5 pr-2",
        isOutlined
          ? "border border-neutral-200 text-neutral-900"
          : [styles!.bg, styles!.text],
        className,
      )}
    >
      {icon && (
        <span className="flex shrink-0 items-center justify-center size-4">
          {icon}
        </span>
      )}
      {label && (
        <span
          className="flex items-center justify-center pl-[2px] text-xs font-medium leading-4 tracking-[0.1px] whitespace-nowrap"
          style={{ fontFeatureSettings: "'ss02' 1" }}
        >
          {label}
        </span>
      )}
    </span>
  );
}
